import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { KeyCodes } from '@fluentui/react';

export const withoutEasyDismiss = (Component) => {
  const HOC = React.memo((props) => {
    const { onClose } = props;

    const onDismiss = useCallback((e) => {
      if (e && (e.type === 'mousedown' || (e.type === 'keydown' && e.keyCode === KeyCodes.escape))) {
        return;
      }
      onClose();
    }, [onClose]);

    return (
      <Component
        {...props}
        onDismiss={onDismiss}
      />
    );
  });

  HOC.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  return HOC;
};
